import PropTypes from 'prop-types';
import React from 'react';
import { css } from 'emotion';
import AbstractForm from 'components/page/process/AbstractForm';
import { getAnchorStyle } from 'styles/base';
import ModalsService from 'services/ModalsService';
import ProcessService from 'services/ProcessService';
import ProcessUtils from 'utils/ProcessUtils';
import { Button } from 'antd';
import { colorBlue, getButtonStyle } from 'styles/base';
import TemplateOptionsForm from 'components/core/forms/TemplateOptionsForm';

const container = css`
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: 10px 10px 10px 20px;
    max-width: 650px;
    .ant-btn {
        ${getButtonStyle('white', colorBlue)}
    }
`;

const sectionTitle = css`
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 5px;
`;

const linkStyle = css`
    font-weight: 700;
    margin: 0 5px 0 5px;
    ${getAnchorStyle()}
`;

const spacer = css`
    margin-top: 5px;
`;

/**
 * This form describes how to create a code project for your process
 */
export default class CreateCodeForm extends AbstractForm {

    static propTypes = {
        process: PropTypes.object,
        processErrors: PropTypes.object,
        dispatch: PropTypes.func,
        hasWritePermissions: PropTypes.bool
    };
    
    hasCreateAdiProjectErrors() {
        const processId = this.props.process.name;
        const parameters = ProcessService.getMyState().projectParametersById[processId].parameters;
        
        const templateIsNull = parameters.project_template === ''; 
        const noProjectName = parameters.project_name === '';
        // TODO? Check for invalid characters

        return templateIsNull || noProjectName;
    }

    setDefaultProjectParameters() {
        const processId = this.props.process.name;
        let parameters = ProcessService.getMyState().projectParametersById[processId];

        parameters = {
            process: processId,
            username: ProcessUtils.getCurrentUsername(),
            process_type: this.props.process.type.toLowerCase(),
            project_name: processId,
            author_name: ProcessUtils.getCurrentUserFullName(),
            phone_number: '',
            email_address: ProcessUtils.getCurrentUserEmail(),
            project_download: 1,
            project_template: ''
        };

        ProcessService.updateCreateProjectParameters(processId, parameters);
    }

    onCreateAdiProject = () => {
        this.setDefaultProjectParameters();

        const form = <TemplateOptionsForm processId={this.props.process.name}/>;

        const onOk = () => {
            let hasNoErrors = false;
            if (!this.hasCreateAdiProjectErrors()) {
                ProcessService.runCreateAdiProject(this.props.process.name);
                hasNoErrors = true;
            }
            return hasNoErrors;
        };

        ModalsService.openModal({
            id: 'select_project_template',
            modalType: ModalsService.TYPE_CONFIRM,
            modalTitle: 'Create ADI Project',
            modalMessage: form,
            onOk
        });
    };

    render() {
        const divStyle = css`
            margin-bottom: 10px;
            margin-top: 5px;
        `;
        return (
            <div className={container}>
                <div className={sectionTitle}>Creating an ADI Project</div>
                <div className={divStyle}>
                    <strong>create_adi_project</strong> is a tool that is used to create an ADI software project from templates. The
                    generated code includes a main routine for running the ADI pipeline along with hooks for inserting
                    custom algorithms.  All production VAPs and Ingests require an ADI project that is checked into
                    code.arm.gov.
                    <div className={spacer}>Click
                        <a href="https://engineering.arm.gov/ADI_doc/pcm.html#create-adi-project"
                            className={linkStyle} target="_blank" rel="noopener noreferrer">HERE</a>
                        for more information.
                    </div>

                </div>
                <div className={divStyle}>
                    <strong>create_adi_project can now be run directly from the PCM!</strong>  Click the button below to run
                    create_adi_project and return the generated code project as a tar.gz archive file.
                </div>
                <div className={divStyle}>
                    <Button onClick={this.onCreateAdiProject}>
                        Create ADI Project
                    </Button>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/page/process/CreateCodeForm.js